import { defineComponent, computed, openBlock, createElementBlock, Fragment, createElementVNode, normalizeStyle, toDisplayString, renderSlot } from "vue";
import { u as useColors } from "../../../composables/useColors.js";
const _hoisted_1 = { class: "va-menu-list__group-name" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaMenuGroup"
  },
  __name: "VaMenuGroup",
  props: {
    groupName: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: "secondary"
    }
  },
  setup(__props) {
    const props = __props;
    const { getColor } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: "va-menu-list__group-name-wrapper",
          colspan: "99999",
          style: normalizeStyle(`--va-color-computed: ${String(colorComputed.value)}`)
        }, [
          createElementVNode("span", _hoisted_1, toDisplayString(__props.groupName), 1)
        ], 4),
        renderSlot(_ctx.$slots, "default", {
          style: normalizeStyle(`--va-color-computed: ${String(colorComputed.value)}`)
        }, void 0, true)
      ], 64);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../VaMenuGroup.css';
//# sourceMappingURL=VaMenuGroup.vue_vue_type_script_setup_true_lang.js.map
